import { Component } from '@angular/core';
import { ActuatorService } from '../../providers/api/actuator.service';
import { ScenesService } from '../../providers/api/scenes.service';
import { AlertController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { ScenesEditPage } from '../../pages/global-settings/scenes/scenes-edit/scenes-edit';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ScenesComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'scenes',
  templateUrl: 'scenes.html'
})
export class ScenesComponent {
  public scenes: any;
  public scene: any;
  public nodesToActuate: any;
  public acceptButtonString:string;
  public cancelButtonString:string;
  public SceneConfigMissingRedirectingToItString: string;
  public SceneActionsBeingRunString:string;
  

  constructor(
    private alertCtrl: AlertController,
    private actuatorService: ActuatorService,
    private scenesService:ScenesService,
    public translateService: TranslateService,
    public navCtrl:NavController,
    public navParams: NavParams
  ) {
    this.translateService.get('ACCEPT_BUTTON').subscribe((value) => {
      this.acceptButtonString = value;
    });
    this.translateService.get('CANCEL_BUTTON').subscribe((value) => {
      this.cancelButtonString = value;
    });
    this.translateService.get('SCENE_CONFIG_NOT_FOUND').subscribe((value) => {
      this.SceneConfigMissingRedirectingToItString = value;
    });
    this.translateService.get('SCENE_ACTIONS_BEING_RUN').subscribe((value) => {
      this.SceneActionsBeingRunString = value;
    });
    
  }

  ngOnInit(){
    this.scenesService.showAll({}).subscribe((response: any) => {
      this.scenes = response.docs.filter(scene=>scene.active === true)
    });
  }

  configScene(id:any)
  {
    let availability = 0;
    let nodes = {};
    this.scenesService.show(id).subscribe((res) => {

      this.scene = res;
      delete this.scene._id;
      delete this.scene.created_at;

      if(this.scene){
        nodes = this.loadCurrentNodes(this.scene.devices)
      }
      for(let key in nodes) {
        if (nodes[key].available === true) {
          availability++;
        }
        if(nodes[key].available){
          for(let i=0; i<nodes[key].endpoints.length; i++){
            let data = nodes[key].endpoints[i];
            if(data.value === null) { continue }
            data = {
              device:nodes[key].id,
              endpoint:nodes[key].endpoints[i].id,
              value:nodes[key].endpoints[i].value
            }
            this.actuatorService.create(data).subscribe((res) => {
              console.log('Updated', res);
            }, (err) => {
              console.error('Update error:::', err);
            });
          }
        }
      } 
      if (availability == 0) {
        this.preRedirect(this.scene.name, this.SceneConfigMissingRedirectingToItString)
      } else {
        this.actionDone(this.scene.name,this.SceneActionsBeingRunString);
      } 
    }, (err) => {
        console.log('Config', err);
    }); 
  }

  loadCurrentNodes(nodes:any[])
  {
    let actualNodes = [];

    for (let i = 0; i < nodes.length; i++) {
      delete nodes[i]._id;
      let nodeId = nodes[i].id;
      actualNodes[nodeId] = {
        id:nodeId,
        available:nodes[i].available,
        active:nodes[i].active,
        endpoints:nodes[i].endpoints
      };
      for (let j = 0; j < nodes[i].endpoints.length; j++) {
        delete nodes[i].endpoints[j]._id;
      }
    }
    return actualNodes;
  }

  preRedirect(name:any,message:any){
    let alert = this.alertCtrl.create({
      title: message.replace("$1", name),
      buttons: [
        { 
          text: this.cancelButtonString,
          role: 'cancel'
        },
        {
          text:this.acceptButtonString,
          handler: () => {
            this.navCtrl.push(ScenesEditPage,this.scene);
          }
        }
      ],
      cssClass:'alertCustom'
    });
    alert.present();
  }
  
  actionDone( name:any,message:any ){
    let alert = this.alertCtrl.create({
      title: message.replace("$1", name),
      buttons: [{
          text: this.acceptButtonString 
      }],
      cssClass:'alertCustom'
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/scenes/scenes.ts